module.exports = __webpack_public_path__ + "static/media/25_iron_metal_seamless.adeaccb9.jpg";